module.exports = __webpack_public_path__ + "static/img/iconmenu06_white.4d0c80c4.svg";